import { render } from "./DailyMessage.vue?vue&type=template&id=187becbd&scoped=true&ts=true"
import script from "./DailyMessage.vue?vue&type=script&lang=ts"
export * from "./DailyMessage.vue?vue&type=script&lang=ts"

import "./DailyMessage.vue?vue&type=style&index=0&id=187becbd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src277174800/src/yosrow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187becbd"]])

export default __exports__